export default __webpack_public_path__ + "static/media/video1.e1260411.mp4";